import * as types from "../constants/ActionTypes";

const numberscontact = (state = [], action) => {
  switch (action.type) {
    case "NUMBERSCONTACT":
      return action.numberscontact.map((numberscontact) => {
        return numberscontact;
      });
    case "DELNUMBERCONTACT":
      return state.filter(
        (numbers) => parseInt(numbers.idphone) !== parseInt(action.number)
      );
    case "ADD_NUMBER_CONTACT":
      return state.concat({
        idphone: action.numberAdd,
        description: "",
        phonetypeid: 3,
        type: 3,
        description: "Celular Pessoal",
        number: action.number,
        midiaid: 1,
      });

    // [
    //   ...state,
    //   {
    //     idphone: action.numberAdd,
    //     description: "",
    //     phonetypeid: 3,
    //     type: 3,
    //     description: "Celular Pessoal",
    //     number: action.number,
    //     midiaid: 1,
    //   },
    // ];

    // state.push({
    //   idphone: action.numberAdd,
    //   description: "",
    //   phonetypeid: 3,
    //   type: 3,
    //   description: "Celular Pessoal",
    //   number: action.number,
    //   midiaid: 1,
    // });
    case "EDITTYPENUMBERCONTACT":
      if (state) {
        return state.map((numbers) => {
          if (parseInt(action.idphone) === parseInt(numbers.idphone)) {
            return {
              ...numbers,
              phonetypeid: action.typenumber,
              description: action.description,
              midiaid: action.midiaid,
            };
          }
          return numbers;
        });
      }
      break;
    case "EDITNUMBERCONTACT":
      if (state) {
        return state.map((numbers) => {
          if (parseInt(action.idphone) === parseInt(numbers.idphone)) {
            return { ...numbers, number: action.number };
          }
          return numbers;
        });
      }
      break;
    case "EDITERRORINSERT":
      if (state) {
        return state.map((numbers) => {
          if (parseInt(action.number) === parseInt(numbers.number)) {
            return { ...numbers, exist: true };
          }
          return numbers;
        });
      }
      break;
    default:
      return state;
  }
};

export default numberscontact;
